import { render } from "./Main.vue?vue&type=template&id=6e5bbf7b"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=6e5bbf7b&lang=scss"
script.render = render

export default script